import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Grid-12.css';
import './Grid-10.css';

const Grid = (props) => {  
  
  let numCol = (props.layout) ? props.layout : props.columns + "col";
  
  let columns = (props.layout === "66-33" || props.layout === "33-66") ? 2 : props.columns;
  
  let gridItemCount = 0;
  
  let gridItems = (React.Children.count(props.children)) ? 
      React.Children.map(props.children, (child, index) => {
        if(child && child.type === GridItem) {
          gridItemCount = (gridItemCount === columns) ? 1 : (gridItemCount + 1);
          
          let wrappedChild = <div className={"g-" + numCol + "--" + gridItemCount} key={index}>{child}</div>;
          
          return wrappedChild;
        }
      }) :
      null;
  
  let gridClasses = classNames( "clearfix", "ccf-grid", {
    "nested-grid": props.isNestedGrid
  });

  return (
    <div className={gridClasses}>
      {gridItems}
    </div>
  );
}

Grid.defaultProps = {
  columns: 1,
  isNestedGrid: false
};

Grid.propTypes = {
  columns: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  isNestedGrid: PropTypes.bool,
  layout: PropTypes.oneOf(['66-33', '33-66'])
}



const GridItem = (props) => {  

  return (
    <span className="grid-item">
      {props.children}
    </span>
  );
}

export { Grid, GridItem }



// WEBPACK FOOTER //
// ./src/shared/components/presentation/grid/Grid.js